import { render, staticRenderFns } from "./TemplateProjectMonthlyReport.vue?vue&type=template&id=37041d04&scoped=true"
import script from "./TemplateProjectMonthlyReport.vue?vue&type=script&lang=js"
export * from "./TemplateProjectMonthlyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37041d04",
  null
  
)

export default component.exports